import { CustomCellRendererProps } from "ag-grid-react";
import { ReactComponent as TaskEdit } from "../assets/img/EditTask.svg";

interface CustomButtonParams extends CustomCellRendererProps {
  data: any;
  onClick: (value: string) => void;
}

export default (params: CustomButtonParams) => {
  return (
    <div className="cursor-pointer" onClick={() => params?.onClick?.(params.data)}>
      <TaskEdit />
    </div>
  );
};
